<template>
    <q-card class="q-dialog-plugin">
        <q-card-section v-if="!props?.mode" class="row items-center q-pb-none"
            style="padding: 2vmin 2vmin 1vmin; height: 7.17vmin;">
            <q-space />
            <q-btn class="close" icon="close" flat round dense v-close-popup />
        </q-card-section>
        <q-separator v-if="!props?.mode" />
        <div style="padding: 2.5vmin" v-if="problem">
            <div style="height: calc( 100vh - 12.27vmin )" :style="!props?.mode ? '' : 'height: calc( 100vh - 5vmin )'">
                <ul class="qlist">
                    <div class="question" v-html="questionHeader"></div>
                    <li class="list_item">
                        <div style="display: flex;flex-direction: row;">
                            <div style="display: flex;flex-direction: column;width: 100%">
                                <div
                                    style="display: flex;flex-direction: row;width: 100%;justify-content: space-between;">
                                    <div style="display: flex;">
                                        <div class="number">
                                            <div
                                                :class="[problem.correctYn === true ? 'marking-correct' : 'marking-wrong']" />
                                            {{ props?.num }}.
                                        </div>
                                        <div style="font-size: 1.4em;" v-html="problem?.problems"></div>
                                    </div>
                                    <div class="icon_box">
                                        <div :class="[problem.answer === '①' && problem.correctYn 
                                        ? 'checked' : problem.answer === '①' && !problem.correctYn ? 'wrong_answer_circle' : 'icon_circle']">
                                            <CusButton :type="problem.answer === '①' && problem.correctYn ? 380 : problem.answer === '①' && !problem.correctYn ? 391 : 361"/>
                                        </div>
                                        <div :class="[problem.answer === '②' && problem.correctYn
                                        ? 'checked_wrong' : problem.answer === '②' && !problem.correctYn ? 'wrong_answer_circle':'icon_circle']">
                                            <CusButton :type="problem.answer === '②' && problem.correctYn ? 390 : problem.answer === '②' && !problem.correctYn ? 392 : 370"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="check_answer">
                                    <div style="display: flex; flex-direction: row;align-items: center;">
                                        <span style="font-weight: 700;font-size: 1.2em">정답</span>
                                        <div :class="problem.correct === '①' ? 'checked_small' : 'checked_small_wrong'">
                                            <q-icon :name="problem.correct === '①' ? 'radio_button_unchecked' : 'close'"
                                                size="1.5em" class='checkedicon' />
                                            <!-- <q-icon v-if="item.correct === '②'" name="close" size="1em" class='checkedicon' /> -->
                                        </div>
                                    </div>
                                    <div style="margin-top: 10px; display: flex; flex-direction: row;align-items: center;">
                                        <span style="font-weight: 700;font-size: 1.2em">해설</span>
                                        <span style="margin-left: 10px;font-size: 1.2em"
                                            v-html="problem.explain"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <q-inner-loading :showing="isLoading" label="" label-class="text-teal" label-style="font-size: 1.1em" />
            </div>
        </div>
    </q-card>
</template>

<script setup>
import { getKrtProblem } from '@/api/modules/qbank';
import { getReportReview } from '@/api/modules/study';
import qbankHeaderVue from "@/components/qbank/header.vue";
import qbankProblem from "@/components/qbank/problem.vue";
import QbankAnswer from '@/components/qbank/qbankAnswer.vue';
import { getAnswerExplain, getEtcInfo, getHeader, getQuestion_old } from '@/helpers/qbankParser/qbankDataParse';
import { analysis } from '@/helpers/qbankParser/qbankMeta';
import { onMounted, watch, ref } from 'vue';
import CusButton from '@/components/widget/CusButton.vue';

const props = defineProps({
    'answerHistorySeq': { default: '0' },
    'num': { default: '1' },
    'mode': { default: null },
});

const studyTree = ref('5083');
const questionHeader = ref(null);
const bookNm = ref(null);
const isLoading = ref(true);
const qBankData = ref(null);
const reviewData = ref({
    reviewContents: null,
    problemId: '',
    correct: '',
    answer: '',
    reAnswer: '',
    correctYn: '',
    reCorrectYn: '',
    problemClassCode: '',
    exprSyncVersion: '',
});
const problem = ref(null)


const onIntersection = () => {

};
const setAnswer = () => {

};
const getData = (seq) => {
    getReportReview({ answerHistorySeq: seq }, (r) => {
        reviewData.value = r;
        getKrtProblem({ version: r.exprSyncVersion, problemId: r.problemId }, (rs) => {
            qBankData.value = rs;
            const tmpStudyTree = rs.content.property.analysis.studyTreeId
            const tmpEtcInfo = getEtcInfo(rs);
            bookNm.value = tmpEtcInfo.bookNm;
            studyTree.value = tmpStudyTree;
            questionHeader.value = getHeader(rs, true);
            // console.log(questionHeader.value);
            problem.value = {
                // problemNo: analysis[rs.content.property.analysis.analysisId]['ord'],
                problemId: r.problemId,
                // analysisOrd: analysis[rs.content.property.analysis.analysisId]['ord'],
                etcInfo: tmpEtcInfo,
                data: rs,
                type: null,
                elapsedTime: 0,
                answer: r.answer,
                reAnswer: r.reAnswer,
                markingType: r.correctYn ? 'right' : 'wrong', //'right': 정답, 'halfWrong':1차오답 , 'halfRight':2차정답 , 'wrong':2차오답
                videoTime: 0,
                relationResult: true,
                // 하단 네비 조정을 위한 변수
                result: {
                    marking: r.correctYn ? 'right' : 'wrong',
                    answer: r.answer
                },              // 채점 여부및 1,2차 정오답 
                done: true,               // 채점및 풀이 확인 완료여부
                scrollCheck: true,             // 해설 끝까지 확인 , 스크롤 하단 갔었는지 체크
                relationId: rs.content.property.problem?.relations?.length > 0 ? rs.content.property.problem?.relations[0].relationId : null,           // 확인 문제 있는지 여부
                completeVideo: true,         // 영상 시청 여부
                // TODO: 큐뱅크 해설영상 파싱필요 
                videoUrl: null,              // 해설 영상 여부
                problemClassCode: r.problemClassCode,
                explain: getAnswerExplain(rs),
                problems: getQuestion_old(rs),
                correctYn: r.correctYn,
                correct: r.correct
            }
            isLoading.value = false;
        })

    });
}
onMounted(() => {
    // console.log('onMounted');
    // console.log(props.answerHistorySeq);
    if (props.answerHistorySeq) {
        getData(props.answerHistorySeq);
    }
})

watch(() => props.answerHistorySeq, (newValue) => {
    // console.log('onMounted');
    // console.log(props.answerHistorySeq);
    if (newValue) {
        getData(newValue);
    }
});

</script>

<style scoped lang="scss">
.question {
    // margin-left: 120px;
    font-size: 1.5em;
    font-weight: 700;
    // margin-top: 30px;
}

.qlist {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 40px 120px;
    height: 80%;
}

.list_item {
    display: flex;
    flex-direction: column;
    padding-top: 12px;

    .number {
        justify-content: center;
        display: flex;
        align-items: flex-start;
        margin-top: 16px;
        font-size: 1.5rem;
        font-weight: bold;
        margin-right: 24px;
    }
}

.icon_box {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.icon_circle {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    border: 1px solid #bbbbbb60;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;
}

.divider {
    width: 100%;
    height: 1px;
    background-color: $divider;
    margin-top: 12px;
}

.bottom_buttons {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 60px;
    justify-content: center;
    align-items: center;
}

.button_icon {
    width: 40px;
    height: 40px;
    background-color: #bbbbbb70;
    border-radius: 50%;
}

.check_answer {
    width: calc(100% - 56px);
    background-color: $gray_200;
    border-radius: 16px;
    margin-top: 12px;
    margin-bottom: 12px;
    padding: 20px;
    margin-left: 56px;
}

.checked {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    border: 1px solid #bbbbbb60;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;
    // background-color: $primary;
    background-color: #4659FF;
}

.checked_wrong {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    border: 1px solid #bbbbbb60;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;
    // background-color: $primary;
    background-color: #EF2B2A;
}

.move_to_core {
    background-color: $primary;
    padding: 10px 16px;
    border-radius: 20px;
    color: $white;
    margin-top: 20px;
    font-weight: 600;
}

.checked_small {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 1px solid #bbbbbb60;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    background-color: #4659FF;

    &_wrong {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: 1px solid #bbbbbb60;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 10px;
        background-color: #EF2B2A
    }
}

.checkedicon {
    color: #fff;
}

.uncheckedicon {
    color: #d9d9d9
}

.popup {
    width: 100%;
    background-color: $white;
    border-radius: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 50px 25px;
    min-height: 460px;
    max-height: 550px;
}

.wrong_answer_circle {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    border: 1px solid#BDBDBD;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;
    background-color: #bdbdbd;
}

.marking {

    &-correct {
        background-image: url('@/assets/images/O.png');
        background-position: 50%;
        background-size: cover;
        width: 90px;
        height: 90px;
        position: absolute;
        z-index: 100;
        margin-top: -22px;
        margin-left: 0px;
    }

    &-hcorrect {
        background-image: url('@/assets/images/OX.png');
        background-position: 50%;
        width: 90px;
        height: 90px;
        position: absolute;
        z-index: 100;
        margin-top: -22px;
        margin-left: 0px;
    }

    &-wrong {
        background-image: url('@/assets/images/X.png');
        background-position: 50%;
        background-size: cover;
        width: 90px;
        height: 90px;
        position: absolute;
        z-index: 100;
        margin-top: -22px;
        margin-left: 0px;
    }

    &-fwrong {
        background-image: url('@/assets/images/XX.png');
        background-position: 50%;
        background-size: cover;
        width: 90px;
        height: 90px;
        position: absolute;
        z-index: 100;
        margin-top: -22px;
        margin-left: 0px;
    }
}
</style>
